import React from 'react'
import {Loader} from '@components/common/base/loader'

export type Size = 'xsmall' | 'small' | 'regular' | 'large' | 'xlarge'

export interface LoaderProps {
  size?: Size
}

export const SharedLoader = (props: LoaderProps) => {
  return <Loader {...props} />
}
